'use strict';

/**
 * @author Maxim Seredkin
 */
export default ['$uibModal', 'StaffRestService',
                function($modal, StaffRestService) {
                    return {
                        select: select,
                        create: create,
                        edit: edit,
                        api: StaffRestService,
                    };

                    function select(staff, filters, def) {
                        return $modal.open({
                            template: require('../view/staff-modal-select.html'),
                            controller: 'StaffModalSelectController',
                            size: 'lg',
                            backdrop: false,
                            resolve: {
                                staff: function() {
                                    return staff;
                                },
                                staffFilters: function() {
                                    return filters != null ? filters : [];
                                },
                                def: () => {
                                    return def;
                                },
                            },
                        });
                    }

                    function create(def) {
                        return $modal.open({
                            template: require('../view/staff-modal-create.html'),
                            controller: 'StaffModalCreateController',
                            size: 'md',
                            backdrop: false,
                            resolve: {
                                staff: function() {
                                    return {
                                        org: (function(def) {
                                            if (def != null && def.org != null) {
                                                return def.org;
                                            }
                                        })(def),
                                    };
                                },
                            },
                        });
                    }

                    function edit(staff) {
                        return $modal.open({
                            template: require('../view/staff-modal-create.html'),
                            controller: 'StaffModalCreateController',
                            size: 'md',
                            backdrop: false,
                            resolve: {
                                staff: function() {
                                    return staff;
                                },
                            },
                        });
                    }
                }];
